import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayoutV2 } from 'src/components/layout/dashboard-layout/dashboard-layout-v2';

export const Route = createFileRoute('/admin-skidog')({
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <DashboardLayoutV2>
      <Outlet />
    </DashboardLayoutV2>
  );
}
